import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';

export const Header = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  width: '100%'
});

export const Message = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.brand.darkGreen
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body7,
  lineHeight: 1.4,
  color: theme.palette.brand.darkGreen
}));

export const Destination = styled('span')(({ theme }) => ({
  fontFamily: theme.typography.body2B.fontFamily
}));

export const CodeArea = styled(Box, {
  shouldForwardProp: prop => prop !== 'disabled'
})<{ disabled: boolean }>(({ disabled }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  width: '100%',
  transition: 'opacity 0.2s ease-in-out',
  ...(disabled && {
    opacity: 0.4,
    pointerEvents: 'none'
  })
}));

export const OtpField = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasError'
})<{ hasError: boolean }>(({ theme, hasError }) => ({
  width: '100%',
  '.Pincode-container': {
    margin: '8px 0'
  },
  '.Pincode-input': {
    fontFamily: theme.typography.subtitle1.fontFamily,
    ...(hasError && {
      borderBottomColor: theme.palette.error.main
    })
  }
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body7B,
  color: theme.palette.error.main
}));

export const Actions = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '16px',
  width: '100%'
});

export const ResendText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body7,
  lineHeight: 1.4,
  color: theme.palette.neutrals.lead
}));

export const ResendLink = styled(ButtonBase)({
  font: 'inherit',
  color: 'inherit',
  verticalAlign: 'baseline',
  textDecoration: 'underline',
  '&.Mui-disabled': {
    opacity: 0.6
  }
});

export const ResendFeedbackText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isError'
})<{ isError: boolean }>(({ theme, isError }) => ({
  ...theme.typography.body7,
  lineHeight: 1.4,
  color: isError ? theme.palette.error.main : theme.palette.brand.darkGreen
}));

export const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2)
}));

export const ContinueButton = styled(Button)(({ theme }) => ({
  ...theme.typography.body7B,
  paddingTop: 0
}));

export const SwitchMethodButton = styled(Button)(({ theme }) => ({
  ...theme.typography.body7B,
  paddingTop: 0
}));
